import axios from "axios";
import { CategoryType } from "enums";
import { CategoryItemLargeModel, CategoryModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import { IAPIResult } from "models/interfaces";
import { Utils } from "utils";

export async function list(): Promise<IAPIResult<CategoryModel[]>> {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<CategoryItemLargeModel[]>>(
    "/api.d/v1/ec/category-item/list"
  );
  // return response.data;

  const tmp = response.data.data;
  const data: CategoryModel[] = [];
  for (let c of tmp) {
    let mList: CategoryModel[] = [];
    if (c.item_medium_category_list) {
      mList = c.item_medium_category_list.map((m) => {
        let sList: CategoryModel[] = [];
        if (m.item_small_category_list) {
          sList = m.item_small_category_list.map((s) => {
            return {
              type: CategoryType.SMALL,
              id: s.item_small_category_id,
              name: s.item_small_category_name,
              sort_no: s.sort_no,
              list: [],
            };
          });
        }
        return {
          type: CategoryType.MIDDLE,
          id: m.item_medium_category_id,
          name: m.item_medium_category_name,
          sort_no: m.sort_no,
          list: sList,
        };
      });
    }
    data.push({
      type: CategoryType.LARGE,
      id: c.item_large_category_id,
      name: c.item_large_category_name,
      sort_no: c.sort_no,
      image: c.item_large_category_image,
      list: mList,
    });
  }

  return {
    data,
    error: response.data.error,
  };
}

export async function create(
  breadcrumb: CategoryModel[],
  name: string,
  image?: CommonFileModel
) {
  if (image) {
    return _create({
      item_category_type: CategoryType.LARGE,
      item_category_name: name,
      item_large_category_image: image,
    });
  } else if (breadcrumb.length === 1) {
    return _create({
      item_category_type: CategoryType.MIDDLE,
      item_category_name: name,
      item_large_category_id: breadcrumb[0].id,
    });
  } else if (breadcrumb.length === 2) {
    return _create({
      item_category_type: CategoryType.SMALL,
      item_category_name: name,
      item_large_category_id: breadcrumb[0].id,
      item_medium_category_id: breadcrumb[1].id,
    });
  }
  throw new Error();
}

export async function _create(
  data:
    | {
        item_category_type: CategoryType.LARGE;
        item_category_name: string;
        item_large_category_image: CommonFileModel;
      }
    | {
        item_category_type: CategoryType.MIDDLE;
        item_category_name: string;
        item_large_category_id: string;
      }
    | {
        item_category_type: CategoryType.SMALL;
        item_category_name: string;
        item_large_category_id: string;
        item_medium_category_id: string;
      }
) {
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/category-item/create",
    data
  );
  return response.data;
}

export async function update(
  data: CategoryModel,
  breadcrumb: CategoryModel[],
  name: string,
  image?: CommonFileModel
) {
  Utils.addDeleteFlag(image);
  if (data.type === CategoryType.LARGE) {
    return _update({
      item_category_type: data.type,
      item_category_name: name,
      item_large_category_id: data.id,
      item_large_category_image: image!,
    });
  } else if (data.type === CategoryType.MIDDLE) {
    return _update({
      item_category_type: data.type,
      item_category_name: name,
      item_large_category_id: breadcrumb[0].id,
      item_medium_category_id: data.id,
    });
  } else if (data.type === CategoryType.SMALL) {
    return _update({
      item_category_type: data.type,
      item_category_name: name,
      item_large_category_id: breadcrumb[0].id,
      item_medium_category_id: breadcrumb[1].id,
      item_small_category_id: data.id,
    });
  } else {
    throw new Error();
  }
}

export async function _update(
  data:
    | {
        item_category_type: CategoryType.LARGE;
        item_category_name: string;
        item_large_category_id: string;
        item_large_category_image: CommonFileModel;
      }
    | {
        item_category_type: CategoryType.MIDDLE;
        item_category_name: string;
        item_large_category_id: string;
        item_medium_category_id: string;
      }
    | {
        item_category_type: CategoryType.SMALL;
        item_category_name: string;
        item_large_category_id: string;
        item_medium_category_id: string;
        item_small_category_id: string;
      }
) {
  const response = await axios.put<IAPIResult<{}>>(
    "/api.d/v1/ec/category-item/update",
    data
  );
  return response.data;
}

export async function del(target: CategoryModel, breadcrumb: CategoryModel[]) {
  if (target.type === CategoryType.LARGE) {
    return _del({
      item_category_type: target.type,
      item_large_category_id: target.id,
    });
  } else if (target.type === CategoryType.MIDDLE) {
    return _del({
      item_category_type: target.type,
      item_large_category_id: breadcrumb[0].id,
      item_medium_category_id: target.id,
    });
  } else if (target.type === CategoryType.SMALL) {
    return _del({
      item_category_type: target.type,
      item_large_category_id: breadcrumb[0].id,
      item_medium_category_id: breadcrumb[1].id,
      item_small_category_id: target.id,
    });
  } else {
    throw new Error();
  }
}

export async function _del(
  data:
    | {
        item_category_type: CategoryType.LARGE;
        item_large_category_id: string;
      }
    | {
        item_category_type: CategoryType.MIDDLE;
        item_large_category_id: string;
        item_medium_category_id: string;
      }
    | {
        item_category_type: CategoryType.SMALL;
        item_large_category_id: string;
        item_medium_category_id: string;
        item_small_category_id: string;
      }
) {
  // await Utils.sleep(300);

  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/category-item/delete",
    { data }
  );
  return response.data;
}

export async function sort(items: CategoryModel[]) {
  const tmp = items.map((v, i) => {
    return {
      item_large_category_id: v.id,
      item_large_category_image: v.image,
      item_large_category_name: v.name,
      item_medium_category_list: v.list.map((vv, ii) => {
        return {
          item_medium_category_id: vv.id,
          item_medium_category_name: vv.name,
          item_small_category_list: vv.list.map((vvv, iii) => {
            return {
              item_small_category_id: vvv.id,
              item_small_category_name: vvv.name,
              sort_no: iii + 1,
            };
          }),
          sort_no: ii + 1,
        };
      }),
      sort_no: i + 1,
    };
  });

  const response = await axios.put<IAPIResult>(
    "/api.d/v1/ec/category-item/sort-update",
    tmp
  );
  return response.data;
}
